import FBConfig from "../FBConfig";

const ReadFirebaseMeal = async () => {
    let syncMealOrders = JSON.parse(localStorage.getItem("meal_orders")) || []
    const outlet_uuid = localStorage.getItem("outlet_uuid")
    if (!outlet_uuid) return console.log("no outlet uuid found in local storage");
    const commentsRef = FBConfig.ref(FBConfig.db, outlet_uuid + "/scheduled_orders/");

    FBConfig.onChildAdded(commentsRef, (data) => {
     
        syncMealOrders = [...syncMealOrders.filter(a => a.order_uuid !== data.val().order_uuid), data.val()]
        localStorage.setItem("meal_orders", JSON.stringify(syncMealOrders))
    });

    FBConfig.onChildChanged(commentsRef, (data) => {
        syncMealOrders = [...syncMealOrders.filter(a => a.order_uuid !== data.val().order_uuid), data.val()]
        localStorage.setItem("meal_orders", JSON.stringify(syncMealOrders))

    });

    FBConfig.onChildRemoved(commentsRef, (data) => {
        // console.log(data.val());
        syncMealOrders = syncMealOrders.filter(a => a.order_uuid !== data.val().order_uuid)
        localStorage.setItem("meal_orders", JSON.stringify(syncMealOrders))

    });

}

export default ReadFirebaseMeal;